var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"card card-default"},[_c('div',{staticClass:"card-header"},[_vm._v(_vm._s(_vm.$t('Dashboard')))]),_c('div',{staticClass:"card-body"},[_vm._v(" "+_vm._s(_vm.$t('Welcome'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }